import { render } from "./VatReports.vue?vue&type=template&id=543a83ba"
import script from "./VatReports.vue?vue&type=script&lang=js"
export * from "./VatReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__